export const GETALL_EVENTS = "GETALL_EVENTS";
export const SET_ALLEVENTS = "SET_ALLEVENTS";
